<div class="ttm-page-title-row" style="background: #293649 url(/assets/images/bg-image/guided-search-updated-banner.jpg) no-repeat bottom right;">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="title-box text-center">
					<div class="page-title-heading">
						<h1 class="title" style="color:white"> Careers</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<section class="ttm-row job_pos-section bg-theme-GreyColor clearfix">
	<div class="container">
		<div class="row">
			<div class="col-lg-12">
				<div class="section-title title-style-center_text">
					<div class="title-header">
						<h4 class="title text-center">Available Positions</h4>
					</div>
				</div>
			</div>
		</div>

		<!-- Filter Bar -->
		<div class="card mb-4 shadow-sm border-0 filter-bar">
			<div class="card-body py-4">
				<!-- NOTE: Assumes component provides arrays: locations, departments and bound vars selectedLocation, selectedDepartment -->
				<form class="row g-3 align-items-end" autocomplete="off" role="search" aria-label="Job filters">
					<div class="col-md-4 col-sm-6">
						<label for="filterLocation" class="form-label small text-uppercase fw-semibold mb-1">Location</label>
						<select id="filterLocation" name="location" class="form-select form-select-sm" [(ngModel)]="selectedLocation">
							<option value="">All locations</option>
							<option *ngFor="let loc of locations" [value]="loc">{{ loc }}</option>
						</select>
					</div>
					<div class="col-md-4 col-sm-6">
						<label for="filterDepartment" class="form-label small text-uppercase fw-semibold mb-1">Department</label>
						<select id="filterDepartment" name="department" class="form-select form-select-sm" [(ngModel)]="selectedDepartment">
							<option value="">All departments</option>
							<option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
						</select>
					</div>
					<div class="col-md-4 col-12">
						<label for="filterKeyword" class="form-label small text-uppercase fw-semibold mb-1">Keyword (optional)</label>
						<input id="filterKeyword" name="keyword" type="text" class="form-control form-control-sm" placeholder="Search title or summary" [(ngModel)]="keyword" />
					</div>
				</form>
			</div>
		</div>

		<!-- Loading & Error States -->
		<div class="row mb-3">
			<div class="col-12" *ngIf="loading">Loading jobs...</div>
			<div class="col-12" *ngIf="error">{{ error }}</div>
			<div class="col-12" *ngIf="!loading && jobs.length === 0">No open positions at the moment.</div>
		</div>

				<!-- Jobs listing -->
				<div class="row" *ngIf="!loading && jobs.length > 0">
					<div class="col-12 mb-3">
						<div class="job-count text-muted small">{{ filteredJobs.length }} position{{ filteredJobs.length === 1 ? '' : 's' }} found</div>
					</div>
					<div class="col-lg-12">
						<div class="row g-3">
							<div class="col-12" *ngFor="let job of filteredJobs; trackBy: trackJob">
								<div class="job-card">
									<div class="job-card__body">
										<div class="row align-items-center w-100">
											<div class="col-md-10">
												<div class="job-card__main">
													<h5 class="job-card__title mb-2">{{ job.title }}</h5>
													<p class="job-card__desc mb-3" *ngIf="job.shortd">{{ job.shortd }}</p>
													<div class="job-card__meta mb-3">
														<span class="job-chip"><i class="ri-map-pin-line"></i>{{ job.job_location || 'Not specified' }}</span>
														<span class="job-chip"><i class="ri-briefcase-line"></i>{{ job.department || 'Not specified' }}</span>
														<span class="job-chip" *ngIf="job.required_exp"><i class="ri-user-line"></i>{{ job.required_exp }}</span>
														<span class="job-chip" *ngIf="job.job_type"><i class="ri-time-line"></i>{{ job.job_type }}</span>
													</div>
													<!-- <div class="job-desc" *ngIf="job.longd" [innerHTML]="job.longd"></div> -->
												</div>
											</div>
											<div class="col-md-2 text-end ">
												<button class="btn btn-primary d-block ml-auto" type="button" (click)="goToDetails(job)">
													Apply Now
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

	</div>
</section>
